import { NgModule } from '@angular/core';
import { TotalTimeService } from './totalTime.service';
import { TotalTimeBackend } from './totalTime.backend';

@NgModule({
  providers: [TotalTimeService, TotalTimeBackend],
})
export class TotalTimeModule {}
